<template>
  <div
    v-if="phoneNumber"
    class="d-inline"
  >
    <div class="d-inline">
      <img
        src="../../assets/images/whatsapp.png"
        style="width: 18px"
        alt="whatsapp"
        class="mx-1"
        @click="openWhatsApp()"
      >
    </div>
    <div class="d-inline">
      <img
        src="../../assets/images/icons8-viber-480.png"
        style="width: 18px"
        alt="whatsapp"
        class="mx-1"
        @click="openViber()"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    phoneNumber: { type: String, default: null }
  },

  methods: {
    openWhatsApp() {
      let phone = this.phoneNumber.replace('+', '')

      // if phone does not start 964 append it
      if (!phone.startsWith('964')) {
        phone = '964' + phone
      }

      window.open(`https://api.whatsapp.com/send?phone=${phone}`)
    },

    openViber() {
      let phone = this.phoneNumber.replace('+', '')

      // if phone does not start 964 append it
      if (!phone.startsWith('964')) {
        phone = '964' + phone
      }

      window.open(`viber://chat?number=${phone}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/openWhatsAppAndViber.vue